import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'

export const NavigationDotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Dots = styled.div`
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  height: 6px;

  ${Media.Phone`
    margin: unset;
  `}
`

export const Dot = styled.div<{ $isActive?: boolean }>`
  width: ${props => (props.$isActive ? '6px' : '4px')};
  height: ${props => (props.$isActive ? '6px' : '4px')};
  border-radius: ${props => (props.$isActive ? '6px' : '4px')};
  background-color: ${props => (props.$isActive ? Colors.Blue50 : Colors.Neutral20)};
  transition: all 0.3s ease;
`
